import { makeVar, InMemoryCache } from '@apollo/client';

export const hamburgerMenuOpen = makeVar<boolean>(false);
export const cache = new InMemoryCache();
